module.exports = __webpack_public_path__ + "static/media/featuredLogo5.ac7a3baa.png";